import { Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '../safe-html.pipe';


interface Column {
  column: string;
  order: number; 
}

interface Row {
  columns: Column[];
  order: number;
}

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, SafeHtmlPipe, DragDropModule]
})
export class TableComponent {
  @ViewChildren('inputRef') inputRefs: QueryList<ElementRef>;
  @Input() organizationKey = ""
  @Input() projectKey = ""
  @Input() userId = ""
  @Input() tableJson = ""
  @Input() isReadOnly = false
  @Input() fieldKey = ""
  @Output() listenTable = new EventEmitter<{"table": string, "fieldKey": string}>();
  emptyTableJson = '{"rows": [{"columns": [{"column": "", "order": 0}, {"column": "", "order": 1}], "order": 0},{"columns": [{"column": "", "order": 0}, {"column": "", "order": 1}], "order": 1}]}'

  table: Row[] = []
  clickedRow = -1
  clickedColumn = -1
  showPopupMenu = false
  isLoadingLabelVisible = false

  constructor() {
  }

  ngAfterViewInit() {
    this.converTableJson()
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.code === 'ArrowUp') {
      this.clickedRow -= 1
      if (this.clickedRow < 0) {
        this.clickedRow = 0
        this.addRow(this.clickedRow, false)
        this.setFocus(this.clickedRow, this.clickedColumn)
      } else {
        this.setFocus(this.clickedRow, this.clickedColumn)
      }
    }
    if (event.code === 'ArrowDown') {
      this.clickedRow += 1
      if (this.clickedRow >= this.table.length) {
        this.clickedRow = this.table.length
        this.addRow(this.clickedRow-1, true)
        this.setFocus(this.clickedRow, this.clickedColumn)
      } else {
        this.setFocus(this.clickedRow, this.clickedColumn)
      }
    }
  }

  setFocus(rowIndex: number, colIndex: number) {
    setTimeout(() => {
      const inputRefIndex = rowIndex+"."+colIndex
      let inputIndex = 0
      this.inputRefs.forEach((inputRef, index) => {
        if (inputRef.nativeElement.getAttribute('data-index') == inputRefIndex) {
          inputIndex = index
        }
      });
      const inputToFocus = this.inputRefs.toArray()[inputIndex]; 
      if (inputToFocus) {
          inputToFocus.nativeElement.focus();
      }
    }, 100)
  }

  converTableJson() {
    setTimeout(() => { 
 //   this.zone.run(() => { 
      if (this.tableJson == undefined || this.tableJson == '') {
        this.tableJson = this.emptyTableJson
      }
      try {
        const parsedData = JSON.parse(this.tableJson) as { rows: Row[] }; // Type assertion
        this.table = parsedData.rows.map(row => ({  // Create new Row objects
          columns: row.columns,
          order: row.order
          })); 
          this.table.sort((rowA, rowB) => rowA.order - rowB.order); 
          this.table.forEach(row => {   
            row.columns.sort((colA, colB) => colA.order - colB.order);
          });
        // ... rest of your code using parsedData.rows
      } catch (error) {
        try {
          const rows = this.convertJsonToRows(JSON.parse(this.tableJson));
          this.table = rows.map(row => ({  // Create new Row objects
          columns: row.columns,
          order: row.order
          })); 
          this.table.sort((rowA, rowB) => rowA.order - rowB.order); 
          this.table.forEach(row => {   
            row.columns.sort((colA, colB) => colA.order - colB.order);
          });
        } catch (error) {
        console.error('Error fetching data:', error);
        this.tableJson = this.emptyTableJson
        }
      }

    }, 0);
  }

  reorderTable() {
    for (let i = 0; i < this.table.length; i++) {
      this.table[i].order = i
      for (let j = 0; j < this.table[i].columns.length; j++) {
        this.table[i].columns[j].order = j
      }
    }
  }

  onRightClick(event: MouseEvent, rowIndex: number, colIndex: number) {
    event.preventDefault();     // Prevent the default browser context menu 
    this.showPopupMenu = true
  }

  closePopupMenu() {
    this.clickedRow = -1
    this.clickedColumn = -1
  }

  addRow(rowIndex: number, isBelow: boolean) {
    if (isBelow == true) {
      rowIndex += 1
    }
    const row: Column[] = []
    const colNum = this.table[0].columns.length
    for (let i = 0; i < colNum; i++) {
      row.push({"column": "", "order": i})
    }
    this.table.splice(rowIndex, 0, {"columns": row, "order": rowIndex})
    this.reorderTable()
    this.updateTableJson()
  }

  addColumn(colIndex: number, isLeft: boolean) {
    if (isLeft == false) {
      colIndex += 1
    }
    for (let i = 0; i < this.table.length; i++) {
      this.table[i].columns.splice(colIndex, 0, {"column": "", "order": colIndex+0.5})
    }
    this.reorderTable()
    this.updateTableJson()
  }

  deleteRow(rowIndex: number) {
    this.table.splice(rowIndex, 1)
    this.updateTableJson()
  }

  deleteColumn(colIndex: number) {
    for (let i = 0; i < this.table.length; i++) {
      this.table[i].columns.splice(colIndex, 1)
    }
    this.updateTableJson()
  }

  onEnterInput(rowIndex: number, colIndex: number) {
    this.clickedRow = rowIndex
    this.clickedColumn = colIndex
    this.showPopupMenu = false
  }

  fieldDropped(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.table, event.previousIndex, event.currentIndex);
    this.reorderTable()
    this.updateTableJson()
  }

  updateTableJson() {
    this.showPopupMenu = false
    this.tableJson = JSON.stringify(this.table);
    this.listenTable.emit({"table": this.tableJson, "fieldKey": this.fieldKey})
  }


  convertJsonToRows(data: any[]): Row[] {
    const rows: Row[] = [];
    
    if (data.length === 0) return rows; // Return empty if no data
  
    // Get the headers (field names)
    const headers = Object.keys(data[0]);
  
    // Create the first row with column names
    const headerRow: Column[] = headers.map((header, index) => ({
      column: header,
      order: index + 1
    }));
  
    rows.push({ columns: headerRow, order: 1 });
  
    // Create rows for each entry in the data
    data.forEach((item, rowIndex) => {
      const columnValues: Column[] = headers.map((header, index) => ({
        column: item[header],
        order: index + 1
      }));
  
      rows.push({
        columns: columnValues,
        order: rowIndex + 2  // Increment for the next row starting with 2
      });
    });
  
    return rows;
  }
}
